// Typed sort options
export interface SortOption {
  label: string;
  key: SearchSort;
}

// Typed sort keys
export type SearchSort = 'most_favorited' | 'recently_updated' | 'relevance';

// The FIRST key listed will be the default.
export const RESOURCE_SORT_OPTIONS: SortOption[] = [
  {label: 'Most Favorited', key: 'most_favorited'},
  {label: 'Recently Updated', key: 'recently_updated'},
  {label: 'Relevance', key: 'relevance'},
];

// The FIRST key listed will be the default.
export const DATA_SEARCH_SORT_OPTIONS: SortOption[] = [
  {label: 'Recently Updated', key: 'recently_updated'},
  {label: 'Relevance', key: 'relevance'},
];
